export default __webpack_public_path__ + "static/media/buzz_quiz.b66bd852.jpeg";